<template>
  <DBox
    :id="'cmp-distribution-statement-sidewindow-catalog'"
    :addButton="false"
    :addLink="false"
    :rightMenu="[    
        {
          text: this.$t('process_groups_btn'),
          value: 'process_groups_btn',
        }
    ]"
    @menuClick="onProcessClick"
  >
    <!-- @add_click="onAddArtist" -->
    <!-- :expandable="true" -->
    <NTable
      class="dbox1"
      id="distribution-statement-catalog"
      :config="tableConfig"
      :headers="Headers"
      :items="list"
      :showNoItems="true"
    >
      <template v-slot:item="{ item , tdcon }">
        <tr>
          <td v-bind="tdcon('assigned_costgroup')">
            <span class="txtov">{{ item['identifier_product'] }}</span>
          </td>
          <td v-bind="tdcon('assigned_group')">
            <Dropdown2
              class="dbox1"
              :showLabel="false"
              :disabled="false"
              :options="costGroupTV"
              :selected="costGroupTV.find(v => v.value == item.cost_group_id)"
              :placeholder="$t('group')"
              v-on:selectedChange="e => onDropdownChange(item, e)"
              :bb="'0px'"
            />
          </td>
          <td v-bind="tdcon('lines')">
            <span class="txtov">{{ item['stmt_lines'] }}</span>
          </td>
          <td v-bind="tdcon('group_amount')">
            <span class="txtov">{{ item['group_amount'] }}</span>
          </td>


        </tr>
      </template>
    </NTable>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { createTV } from '../../../../models/text-value.model';

export default {
  props: {
    selectedStatementDetails: {
      type: Object
    }
  },
  components: {
    NTable,
    DBox
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      })
    };
  },
  computed: {
    Headers: function() {
      return [
        createTableHeader("assigned_costgroup", { text:'Incoming Costgroup' }),
        createTableHeader("assigned_group", {}),
        createTableHeader("lines", { }),
        createTableHeader("group_amount", { ta:'right'}),

        
      ];
    },
    currentChannel:function(){
      return this.selectedStatementDetails?.stmt?.digital_physical
    },

    costGroupTV:function(){
      console.log("this.selectedStatementDetails?.costgroups",this.selectedStatementDetails?.costgroups)
      if(this.currentChannel=='costs'){
        return createTV(this.selectedStatementDetails?.costgroups,'cost_group_name','cost_group_id');
      }else{
        return createTV(this.selectedStatementDetails?.costgroups.filter(x=>x.income_flag==1),'cost_group_name','cost_group_id');
      }
      
      
    },

    list: function() {
      return this.selectedStatementDetails.costgroup_lines.map((x,i)=>{
        return {
          ...x,
          index:i
        }
      }) || [];
    },


  },
  methods: {

    onProcessClick:function(){
      const mappedGroup = this.list.map(x=>{
        return{
          cost_group_id:x.cost_group_id,
          group:x.identifier_product
        }
      }) ;

      console.log(":::::::",mappedGroup)
      this.$emit('processGroup',mappedGroup)
    },
    onDropdownChange:function(item, e){
      console.log(item,"item",this.list)
      const item_id = item.cost_group_id;
      const value = e.value;
      console.log(item_id,"e",value)
      this.$emit('update',{item_id,value,index:item.index})

    },

  }
};
</script>
